import { Text, View } from '@react-pdf/renderer';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../..';
import { CURRENCY } from '../../../../interfaces/enumerables';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';
import { isDocTypeDeliveryNote } from '../../../../services/utils/myDataUtils';
import { getCustomerNewSubtotal } from '../../../../services/utils/pdf';

interface Props {
  doc: InvoiceInterface;
}

export const PdfCustomerDebt = ({ doc }: Props) => {
  const { t } = useTranslation();
  const newTotal = useMemo(() => getCustomerNewSubtotal(doc), [doc]);
  const currencySymbol = useMemo(() => CURRENCY[doc?.currency || 'EUR'], [doc?.currency]);
  const hideSection = useMemo(() => isDocTypeDeliveryNote(doc?.documentType?.aadeCode), [doc?.documentType?.aadeCode]);

  if (hideSection || doc?.currentSubtotal === null) return null;

  return (
    <View style={[pdfStyles.column, pdfStyles.simpleBorder]}>
      <Text style={pdfStyles.smallTitle}>{t('SALE.CUSTOMER_DEBT')}</Text>
      <Text style={pdfStyles.smallTitleRegular}>
        {t('SALE.OLD_DEBT')}:
        <Text style={pdfStyles.smallTitle}>
          {doc?.currentSubtotal} {currencySymbol}
        </Text>
      </Text>
      <Text style={pdfStyles.smallTitleRegular}>
        {t('SALE.NEW_DEBT')}:{' '}
        <Text style={pdfStyles.smallTitle}>
          {newTotal} {currencySymbol}
        </Text>
      </Text>
    </View>
  );
};
